import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import ServicePage from "./pages/Services/ServicePage";
import ServiceDetails from "./pages/Services/ServiceDetails";
import DetailingPage from "./pages/DetailingServices/Detailing";
import About from "./pages/About/About";

function Router() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<ServicePage />} />
      <Route path="/service/:slug" element={<ServiceDetails />} />
      <Route path="/detailing" element={<DetailingPage />} />
      <Route path="/about" element={<About />} />
    </Routes>
  );
}

export default Router;
